// 9fbef606107a605d69c0edbcd8029e5d
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  getIconPath,
  configureInternalNavigationFromCMSUrl,
  getViewportInfo,
  styleOverrideEngine,
} from '@tcp/core/src/utils';
import Carousel from '@tcp/core/src/components/common/molecules/Carousel/views/Carousel';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';
import Image from '@tcp/core/src/components/common/atoms/Image';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import LabelsContext from '@tcp/core/src/components/common/context/LabelsContext';
import {
  GLOBAL_ACCESSIBILITY_LABELS,
  GlobalAccessibilityLabels,
} from '@tcp/core/src/utils/labels/globalAccessibility.labels';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import withStyles from '../../../hoc/withStyles';
import styles, { Container, SmoothScrollWrapper } from '../styles/JeansModule.style';

const CAROUSEL_OPTIONS = {
  autoplay: false,
  arrows: true,
  fade: false,
  speed: 1000,
  lazyLoad: false,
  dots: false,
  swipe: true,
  slidesToShow: 7,
  slidesToScroll: 1,
  infinite: false,
  responsive: [
    {
      breakpoint: 1920,
      settings: {
        slidesToShow: 5,
        swipeToSlide: false,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 2560,
      settings: {
        slidesToShow: 6,
        swipeToSlide: false,
        slidesToScroll: 1,
      },
    },
  ],
};

const CAROUSEL_OPTIONS_UNMOUNT = {
  autoplay: false,
  arrows: true,
  fade: false,
  speed: 1000,
  lazyLoad: false,
  dots: false,
  swipe: true,
  slidesToShow: 7,
  slidesToScroll: 1,
  infinite: false,
  responsive: [
    {
      breakpoint: 1920,
      settings: {
        slidesToShow: 5,
        swipeToSlide: false,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 2560,
      settings: {
        slidesToShow: 6,
        swipeToSlide: false,
        slidesToScroll: 1,
      },
    },
  ],
};

export class JeansModule extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    accessibility: PropTypes.shape({
      lbl_tick_icon: PropTypes.string,
      lbl_plus_icon: PropTypes.string,
    }),
    headLine: PropTypes.shape([]),
    imageTileWrapper: PropTypes.shape([]),
    isPromoForMobile: PropTypes.bool,
  };

  static defaultProps = {
    headLine: [],
    imageTileWrapper: [],
    className: '',
    accessibility: {},
    isPromoForMobile: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      isSmoothScroll: false,
      hasMounted: false,
    };
    this.accessibilityLabels = getLabelFromCopyOrFromTranslation(
      GLOBAL_ACCESSIBILITY_LABELS,
      GlobalAccessibilityLabels
    );

    this.lblTickIcon = renderLabel(this.accessibilityLabels.lbl_tick_icon, 'lbl_tick_icon');
    this.lblPlusIcon = renderLabel(this.accessibilityLabels.lbl_plus_icon, 'lbl_plus_icon');
  }

  componentDidMount() {
    const { isMobile, isTablet } = getViewportInfo() || {};
    this.setState({ isSmoothScroll: isMobile || isTablet, hasMounted: true });
  }

  setHplpFlag = () => {
    const { setFromHplpFlag, fromHplp } = this.props;
    if (fromHplp) {
      setFromHplpFlag(true);
    }
  };

  static contextType = LabelsContext;

  renderItems = (
    imageTileWrapper,
    accessibility,
    jeansV2Design,
    isDamImageV2Enabled,
    className = ''
  ) => {
    return imageTileWrapper.map(
      ({ imageStyled, headLine, subHeadLine, textList, singleCTAButton }, index) => {
        const toPath = configureInternalNavigationFromCMSUrl(singleCTAButton.url);
        const preloadImage = index <= 5;
        const v2DesignClassName = jeansV2Design ? 'jeans-carousel-v2-design' : '';

        return (
          <div
            className={`jeans-carousel ${className} ${v2DesignClassName}`}
            key={index.toString()}
          >
            {jeansV2Design ? (
              <div className="aspect-ratio-box">
                <Anchor
                  className="image-link"
                  to={toPath}
                  onClick={this.setHplpFlag}
                  asPath={singleCTAButton.url}
                  dataLocator="dummy-datalocator"
                >
                  <DamImage
                    className="carousel-image aspect-ratio-box-inside"
                    imgData={{
                      alt: imageStyled[0].image.alt,
                      url: imageStyled[0].image.url,
                    }}
                    preloadImage={preloadImage}
                    lazyLoadImage={!preloadImage}
                    isDamImageV2Enabled={isDamImageV2Enabled}
                    isHomePage
                  />
                </Anchor>
              </div>
            ) : (
              <Anchor
                className="image-link"
                to={toPath}
                onClick={this.setHplpFlag}
                asPath={singleCTAButton.url}
                dataLocator="dummy-datalocator"
              >
                <div className="aspect-ratio-box-v1">
                  <DamImage
                    className="carousel-image aspect-ratio-box-inside"
                    imgData={{
                      alt: imageStyled[0].image.alt,
                      url: imageStyled[0].image.url,
                    }}
                    preloadImage={preloadImage}
                    lazyLoadImage={!preloadImage}
                    isDamImageV2Enabled={isDamImageV2Enabled}
                    isHomePage
                  />
                </div>
                <BodyCopy
                  className="image-text"
                  fontSize="fs14"
                  fontWeight="black"
                  fontFamily="secondary"
                >
                  {imageStyled[0].styled.text}
                </BodyCopy>
                <div className="overlapping-section">
                  <div className="text-container">
                    <BodyCopy
                      className="text-header"
                      textAlign="center"
                      fontSize="fs20"
                      fontWeight="bold"
                      fontFamily="primary"
                    >
                      {headLine[0].text}
                    </BodyCopy>
                    <BodyCopy
                      className="text-subheader"
                      textAlign="center"
                      fontWeight="semibold"
                      fontSize="fs12"
                      fontFamily="primary"
                    >
                      {subHeadLine[0].text}
                    </BodyCopy>
                    {textList.map((textItem) => {
                      return (
                        <div className="text-line elem-mb-XS_1">
                          <Image
                            className="done-button"
                            src={getIconPath('confirmation-check')}
                            alt={this.lblTickIcon}
                          />
                          <BodyCopy
                            className="text-item"
                            fontSize="fs14"
                            fontWeight="extrabold"
                            textAlign="center"
                            fontFamily="secondary"
                            lineHeight="lh1"
                          >
                            {textItem.text}
                          </BodyCopy>
                        </div>
                      );
                    })}
                    <Image
                      className={`${imageStyled[0].styled.style} plus-icon`}
                      src={getIconPath('plus')}
                      alt={this.lblPlusIcon}
                    />
                  </div>
                  <div
                    className="shop-now-link"
                    dataLocator="dummy-datalocator"
                    fontSizeVariation="large"
                    fontFamily="secondary"
                  >
                    {singleCTAButton.text}
                  </div>
                </div>
              </Anchor>
            )}
          </div>
        );
      }
    );
  };

  render() {
    const {
      headLine: titleHeadLine,
      imageTileWrapper,
      className,
      accessibility,
      isPromoForMobile,
      moduleClassName,
    } = this.props;
    const { extraConfig } = this.context;
    const { isDamImageV2Enabled } = extraConfig || {};
    const styleOverrides = moduleClassName && styleOverrideEngine(moduleClassName, 'JeansModule');
    const { 'v2-design': { jeansV2Design = false } = {} } = styleOverrides || {};
    const { isSmoothScroll, hasMounted } = this.state;
    const v2ClassName = jeansV2Design ? 'jeans-v2-design-module' : '';
    const isItemLengthLessThanSix = imageTileWrapper && imageTileWrapper.length <= 6;
    return (
      <Container
        className={`${className} jeans-module ${v2ClassName}`}
        isV2DesignEnabled={jeansV2Design}
      >
        {!jeansV2Design && titleHeadLine && titleHeadLine[0] ? (
          <div className="title-section">
            <BodyCopy
              fontSize="fs16"
              fontWeight="extrabold"
              fontFamily="secondary"
              color="white"
              textAlign="center"
              className="elem-pt-XXS elem-pb-XXS"
            >
              {titleHeadLine[0].text}
            </BodyCopy>
          </div>
        ) : null}
        {isSmoothScroll || isPromoForMobile ? (
          <SmoothScrollWrapper
            className="smooth-scroll-list"
            isItemLengthLessThanSix={isItemLengthLessThanSix}
          >
            {this.renderItems(
              imageTileWrapper,
              accessibility,
              jeansV2Design,
              isDamImageV2Enabled,
              'smooth-scroll-list-item'
            )}
          </SmoothScrollWrapper>
        ) : (
          <Carousel
            className="carousel-item"
            options={hasMounted ? CAROUSEL_OPTIONS : CAROUSEL_OPTIONS_UNMOUNT}
            carouselConfig={{
              autoplay: false,
              customArrowLeft: getIconPath('carousel-big-carrot'),
              customArrowRight: getIconPath('carousel-big-carrot'),
            }}
            mountedSetting={true}
          >
            {this.renderItems(imageTileWrapper, accessibility, jeansV2Design, isDamImageV2Enabled)}
          </Carousel>
        )}
      </Container>
    );
  }
}

export { JeansModule as JeansModuleVanilla };
export default withStyles(JeansModule, styles);
